import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import moment from 'moment';

import { Filter, Main } from 'Containers';
import { ReportGeneration } from 'Common/ObjectHelper';
import { toastInfo, toastError } from 'Common/ToastHelper';
import EligibilityByApplicationForm from './components/EligibilityByApplicationForm';
import { getReport, clearReport } from 'State/report/actions';
import { ELIGIBILITY_BY_APPLICATION_REPORT_FORM_NAME } from 'Common/FormEnum';
import { EligibilityByApplicationReportEnum } from 'Common/FieldEnum';
import { ProvisionTypeEnum } from 'Common/Constants/Enumeration/ProvisionTypeEnum';
import { defaultDateFormat } from 'Common/GeneralHelper';
import {
  getReportData,
  getReportError,
  getReportFetching,
} from 'State/selectors';

class EligibilityByApplicationContainer extends Component {
  componentDidUpdate(prevProps) {
    const { report, error, clearReport } = this.props;

    if (!prevProps.error && error) {
      toastError(error.Message || error.Title);
    }

    if (report !== null && report !== prevProps.report) {
      if (report === '') {
        toastInfo('No data found!');
      } else {
        ReportGeneration(report, 'Eligibility By Application Report');
      }

      clearReport();
    }
  }

  submitForm = values => {
    this.props.getReport('Reports/EligibilityByAppTypeReport', values);
  };

  getMainProps = () => {
    const { fetching } = this.props;

    return {
      toolbox: {
        formName: ELIGIBILITY_BY_APPLICATION_REPORT_FORM_NAME,
        saveButtonProps: {
          content: 'View',
          loading: fetching,
          disabled: fetching,
        },
        shown: true,
      },
    };
  };

  render() {
    const { fetching } = this.props;

    return (
      <Fragment>
        <Filter title="Eligibility By Application Report" />
        <Main {...this.getMainProps()}>
          <EligibilityByApplicationForm
            onSubmit={this.submitForm}
            initialValues={{
              [EligibilityByApplicationReportEnum.ProvisionType]:
                ProvisionTypeEnum.BOTH,
              [EligibilityByApplicationReportEnum.AsOfDate]: defaultDateFormat(
                moment()
              ),
              [EligibilityByApplicationReportEnum.IncludeApplicationSummary]: false,
            }}
            isFetching={fetching}
          />
        </Main>
      </Fragment>
    );
  }
}

const mapStateToProps = state => {
  return {
    report: getReportData(state),
    error: getReportError(state),
    fetching: getReportFetching(state),
  };
};

export const EligibilityByApplication = withRouter(
  connect(mapStateToProps, { getReport, clearReport })(
    EligibilityByApplicationContainer
  )
);



// WEBPACK FOOTER //
// ./src/pages/eligibilityByApplicationReport/EligibilityByApplication.js